import { TransactionStatus } from '@train-protocol/sdk';
export async function getTransaction(provider, txHash) {
    try {
        const receipt = await provider.getTransactionReceipt(txHash);
        if (!receipt)
            return null;
        const executionStatus = 'execution_status' in receipt
            ? receipt.execution_status
            : undefined;
        return {
            hash: txHash,
            status: executionStatus === 'REVERTED'
                ? TransactionStatus.Failed
                : executionStatus === 'SUCCEEDED'
                    ? TransactionStatus.Confirmed
                    : TransactionStatus.Pending,
            blockNumber: 'block_number' in receipt
                ? String(receipt.block_number)
                : undefined,
        };
    }
    catch {
        return null;
    }
}
